import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { CalendarTaskItem, ICalendarTaskItem } from "./calendarTaskItem";

export interface ICalendarTaskListItems extends ListItems<ICalendarTaskItem> {
    totalItemCount: number;
}

export class CalendarTaskListItems extends ListItems<CalendarTaskItem> implements ICalendarTaskListItems {
    totalItemCount: number;

    constructor();
    constructor(obj: ICalendarTaskListItems);
    constructor(obj?: any) {
        super(obj);
        this.totalItemCount = obj && obj.totalItemCount || 0;
        this.items = Base.getTypedArray(obj ? obj.items : null, CalendarTaskItem);
    }
}